// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Checkbox_checkbox__3TN5x","checkbox_checked":"Checkbox_checkbox_checked__LPfnn"};